import { StateSchema } from 'app/providers/StoreProvider';

import { UserPermissions } from '../consts/userConsts';

// Order
export const getUserCanEditPendingApprovalOrder = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.EDIT_PENDING_APPROVAL_ORDER,
    );
export const getUserCanEditInReviewOrder = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.EDIT_IN_REVIEW_ORDER,
    );

export const getUserCanRejectOrder = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(UserPermissions.REJECT_ORDER);

export const getUserCanApproveOrder = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(UserPermissions.APPROVE_ORDER);

export const getUserCanMoveOrderToPendingApproval = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.MOVE_ORDER_TO_PENDING_APPROVAL,
    );

export const getUserCanAddOrder = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(UserPermissions.ADD_ORDER);

// Order item
export const getUserCanAddOrderItem = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.ADD_ORDER_ITEM,
    );

export const getUserCanDeleteOrderItem = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.DELETE_ORDER_ITEM,
    );

export const getUserCanChangeOrderItem = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.CHANGE_ORDER_ITEM,
    );

export const getUserCanSeePrices = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.CAN_SEE_PRICES,
    );

export const getUserCanEditCatalogCategories = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.EDIT_CATALOG_CATEGORIES,
    );

export const getUserCanManageCatalogItems = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.MANAGE_CATALOG_ITEMS,
    );

export const getUserCanManageCustomLists = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.MANAGE_CUSTOM_LISTS,
    );

export const getUserCanOrderFromCustomLists = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.ORDER_FROM_CUSTOM_LISTS,
    );

export const getUserCanDownloadLabels = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.API_DOWNLOAD_LABELS,
    );

export const getUserCanDownloadSelectedLabels = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.API_DOWNLOAD_LABELS,
    );

export const getUserCanSeeCatalogCompliance = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.API_SEE_CATALOG_COMPLIANCE,
    );

export const getUserCanSeeSavingsInsights = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.API_SEE_SAVINGS_INSIGHTS,
    );

export const getUserCanSeeSpendInsights = (state: StateSchema) =>
    state.profile.data?.permissionsList.includes(
        UserPermissions.API_SEE_SPEND_INSIGHTS,
    );

/**
 * Permissions used for route-level guarding. Add a permission here when a route
 * should be gated by it (route config uses permission: UserPermissions.XXX).
 */
export const routePermissionSelectors: Record<
    string,
    (state: StateSchema) => boolean
> = {
    [UserPermissions.API_SEE_CATALOG_COMPLIANCE]:
        getUserCanSeeCatalogCompliance,
    [UserPermissions.API_SEE_SAVINGS_INSIGHTS]: getUserCanSeeSavingsInsights,
    [UserPermissions.API_SEE_SPEND_INSIGHTS]: getUserCanSeeSpendInsights,
};
